export const ARCHIVE_SEARCH = "@archive/ARCHIVE_SEARCH";
export const ARCHIVE_SEARCH_RESET = "@archive/ARCHIVE_SEARCH_RESET";
export const SET_PAGE_NO = "@archive/SET_PAGE_NO";
export const SET_ARCHIVE = "@archive/SET_ARCHIVE";
export const SET_ARCHIVE_COUNT = "@archive/SET_ARCHIVE_COUNT";